import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { persistAuthPlugin } from './plugins';

export default {
  state,
  getters,
  actions,
  mutations,
  plugins: [persistAuthPlugin],
  strict: process.env.NODE_ENV === 'development',
};
